<div class="titleBox"> <h1 style="color: #424242;
  letter-spacing: -0.05em;">Employees</h1></div>
<div><hr></div>
<br>
<br>
<button class="buttonAddNew" mat-raised-button (click)="addDialog()" style="margin-left: 0;
color: #424242;"> Add New Employee</button>
<button class="buttonAddNew" mat-raised-button routerLink="/employee-tree" style="margin-left: 8px;
color: #424242;"> View Employee Tree</button>

      <ngx-table [configuration] = "configuration"  [data]= "gridEntrie$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate">
          <ng-template let-row>
            <td style="width:25%;">
              <div>
                {{row.employee_name}}
                <!--
                <span class="editSpan" (click)="openDialog(row)" style="float: right;
                color: #424242;"><fa-icon [icon]="faedit"></fa-icon></span> -->
              </div>
            </td>

            <td>
                <div>
                  {{row.phone}}
                </div>
            </td>

            <td>
              <div>
                {{row.initials}}
              </div>
            </td>

            <td>
              <div>
                {{row.e_mail}}
              </div>
            </td>

            <td>
                <div>
                  <button button mat-raised-button color="green" (click)="openDialog(row)">
                    <fa-icon [icon]="faedit"></fa-icon>
                  </button>
                </div>
            </td>
          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>
<div>
<button class="buttonAddNew" mat-raised-button (click)="wrongEmployeesDialog()" style="color:#424242;"> Check Supervisors</button>
<button class="buttonAddNew" mat-raised-button routerLink="/employee-tree" style="margin-left: 8px; color:#424242;"> View Employee Tree</button>
</div>

